import { render, staticRenderFns } from "./SingleOrderDetail.vue?vue&type=template&id=1e9412e8&scoped=true&"
import script from "./SingleOrderDetail.vue?vue&type=script&lang=js&"
export * from "./SingleOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./SingleOrderDetail.vue?vue&type=style&index=0&id=1e9412e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e9412e8",
  null
  
)

export default component.exports